import axiosInstance from "../instance/axiosInstance";
import commonInstance from "../instance/commonInstance";

class PropertiesApi {
  static async getPropertiesList() {
    try {
      const response = await axiosInstance.get("/property/listing");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getSingleProperty(id) {
    try {
      const response = await commonInstance.get(`/property/listing-view/${id}`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async deleteSingleProperty(id) {
    try {
      const response = await axiosInstance.get(
        `/property/listing-delete/${id}`
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async removePropertyImages(data) {
    try {
      const response = await axiosInstance.post(
        `/property/images-remove`,
        data
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async changePropertyStatus(hashId) {
    try {
      const response = await axiosInstance.get(
        `/property/marked-as-sold/${hashId}`
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async saveProperty(formData) {
    try {
      const response = await axiosInstance.post(
        "/property/listing-save",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async uploadPropertyMedia(file, onUploadProgress) {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axiosInstance.post(
        "/property/media/upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (event) => {
            if (onUploadProgress && event.total) {
              onUploadProgress(event.loaded / event.total);
            }
          },
        }
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getPresignedURLs(formData) {
    try {
      const response = await axiosInstance.post(
        "/property/media/create-presigned-url",
        formData
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async finalizeUpload(formData) {
    try {
      const response = await axiosInstance.post(
        "/property/media/finalize-upload",
        formData
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async addLookingForProp(formData) {
    try {
      const response = await axiosInstance.post("/looking-for/save", formData);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getListingStatuses() {
    try {
      const response = await commonInstance.get("/listing-statuses");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getListingPropertyTypes() {
    try {
      const response = await axiosInstance.get("/property/listing-property-types");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getLookingForList() {
    try {
      const response = await axiosInstance.get("/looking-for/list");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getSingleLookingFor(id) {
    try {
      const response = await axiosInstance.get(`/looking-for/view/${id}`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async deleteSingleLookingFor(id) {
    try {
      const response = await axiosInstance.get(
        `/looking-for/delete/${id}`
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
}

export default PropertiesApi;
